import { queryOptions } from '@tanstack/react-query'

import { QueryKeys } from '@/configs/query'
import { siteApi } from '@/lib/api/site-client'
import { apiPaths } from '@/lib/api/public-api'
import {
  buildCareersListParams,
  type CareersApiResponse,
  type CareersListOptions,
} from '@/lib/api/careers'

export const careersListQuery = (departmentSlug?: string, locale?: string) => {
  const options: CareersListOptions = departmentSlug ? { departmentSlug } : {}
  return queryOptions<CareersApiResponse>({
    queryKey: [...QueryKeys.CAREERS, 'list', departmentSlug ?? 'all', locale],
    queryFn: () =>
      siteApi.get<CareersApiResponse>({
        url: `/api${apiPaths.careers}`,
        params: { ...buildCareersListParams(options), ...(locale ? { lang: locale } : {}) },
      }),
  })
}
